var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_5a8a838c"]},_vm.$listeners),[_c('cube-divider',{attrs:{"text":"文本内容"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }